export default "__VITE_ASSET__6f0ef799__"